let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4jXQD")).then(() => parcelRequire('8QRyJ'));